import {oidcEarlyInit} from 'oidc-spa/entrypoint'
import './styles/LoadingText.css'

const {shouldLoadApp} = oidcEarlyInit({
	freezeFetch: true,
	freezeXMLHttpRequest: true,
})

if (shouldLoadApp) {
	import('./index.lazy')
}
